/**
 *  Audio
 *
 *  Created by Legman on 12/09/2016.
 *
 */

/**
 * @constructor
 */
function Audio() {
    /**
     * @type {number}
     */
    this.id = -1;

    /**
     * @type {Howl}
     */
    this.howl = null;
}
module.exports = Audio;

Audio.prototype.destroy = function() {
    this._onend && this.howl.off("end", this._onend);
    this.stop();
};

Audio.prototype.play = function() {
    this.howl.play(this.id);
};

Audio.prototype.stop = function() {
    this.howl.stop(this.id);
};

Audio.prototype.pause = function() {
    this.howl.pause(this.id);
};
